import CheckSignOff from '../../components/CheckSignOff';
import React from 'react';
import { HiChevronLeft } from 'react-icons/hi';
import { BiChevronRight, BiChevronDown } from 'react-icons/bi';
import { FiCalendar, FiClock } from 'react-icons/fi';
import { LuUsers } from 'react-icons/lu';

export default function StaffTrainingHeader() {
  return (
    <header className="w-full bg-white p-6 font-sans select-none">
      {/* Top Navigation Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        {/* Breadcrumb Navigation */}
        <nav className="flex items-center space-x-1 text-sm font-medium text-blue-600">
          <HiChevronLeft className="w-5 h-5 cursor-pointer text-blue-700 stroke-[3]" />
          <span className="hover:underline cursor-pointer">Checks</span>
          <BiChevronRight className="w-5 h-5 text-gray-400" />
          <span className="text-gray-600 font-normal">Staff Training Check (Monthly)</span>
        </nav>

        {/* Date Selector & View History Button Row */}
        <div className="flex items-center space-x-3">
          {/* Calendar Picker Dropdown */}
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 transition text-sm font-semibold text-gray-800 shadow-sm">
            <FiCalendar className="w-4 h-4 text-gray-500" />
            <span>18 Jul 2026</span>
            <BiChevronDown className="w-4 h-4 text-gray-500" />
          </button>

          {/* View History Control */}
          <button className="flex items-center space-x-2 px-4 py-2 border border-gray-200 rounded-xl bg-white hover:bg-gray-50 transition text-sm font-semibold text-gray-800 shadow-sm">
            <FiClock className="w-4 h-4 text-gray-500" />
            <span>View History</span>
          </button>
        </div>
      </div>

      {/* Main Bottom Details Content Row */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
        {/* Left Side Grouping: Main Module Icon, Text Content and Badges */}
        <div className="flex items-start space-x-4 max-w-3xl">
          {/* Main Users/Staff Logo Rounded Block */}
          <div className="flex-shrink-0 w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-md shadow-blue-100">
            <LuUsers className="w-8 h-8 text-white" />
          </div>

          {/* Text Summary Info Content Stack */}
          <div className="space-y-1.5">
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
                Staff Training Check (Monthly)
              </h1>
              {/* Recurrence Badge Marker */}
              <span className="inline-flex items-center space-x-1 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-bold border border-blue-100/50">
                <FiClock className="w-3.5 h-3.5 text-blue-600" />
                <span>Monthly Check</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm md:text-base font-normal leading-relaxed text-left">
              Review staff training records, completion status and training needs.
            </p>
          </div>
        </div>

        {/* Right Action Trigger Block */}
        <div className="flex-shrink-0 self-end lg:self-start">
          <CheckSignOff slug="staff-training-check" label="Save & Complete" />
        </div>
      </div>
    </header>
  );
}
